import * as sessionActionCreators from 'store/actionCreators/sessions';
import * as clientActions from 'store/actions/dataSources/clients';
import * as eventActions from 'store/actions/dataSources/events';
import * as resourceActions from 'store/actions/dataSources/resources';
import * as staffActions from 'store/actions/dataSources/staff';

import { sessionSource } from 'sources';
import { SessionParams } from 'sources/SessionSource';
import { AppThunk } from 'store/store';
import { setError } from 'store/actions/app';

export const list = (params: SessionParams): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    dispatch(sessionActionCreators.setLoading(true));
    const results = await sessionSource.List(params);
    const { records: sessions } = results;

    if (sessions.length) {
      await Promise.all([
        dispatch(staffActions.listAll({ sessionIds: sessions.map(s => s.id) })),
        dispatch(eventActions.listAll({ ids: sessions.map(s => s.eventId) })),
        dispatch(
          resourceActions.listAll({ ids: sessions.flatMap(s => s.resourceIds) })
        ),
      ]);
    }

    dispatch(sessionActionCreators.listSuccess(results));
    dispatch(sessionActionCreators.setLoading(false));
  } catch (e) {
    dispatch(setError(e?.message));
    dispatch(sessionActionCreators.setLoading(false));
  }
};

export const fetch = (id: string): AppThunk => async (
  dispatch: any
): Promise<void> => {
  try {
    dispatch(sessionActionCreators.setLoading(true));
    const session = await sessionSource.Fetch(id);

    await Promise.all([
      dispatch(staffActions.listAll({ sessionIds: [id] })),
      dispatch(eventActions.listAll({ ids: [session.eventId] })),
      dispatch(resourceActions.listAll({ ids: session.resourceIds })),
      dispatch(clientActions.list({ sessionIds: [id] })),
    ]);
    dispatch(sessionActionCreators.fetchSuccess(session));
    dispatch(sessionActionCreators.setLoading(false));
  } catch (e) {
    dispatch(setError(e?.message));
    dispatch(sessionActionCreators.setLoading(false));
  }
};
